module.exports = __webpack_public_path__ + "assets/img/dayu_logo.5f00e907.png";